/**
 * @generated SignedSource<<4711eaeef164fee44f29f5a5634a6961>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedOriginalLanguageProvider_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedOriginalLanguageProvider_item";
};
export type PdpSharedOriginalLanguageProvider_item$key = {
  readonly " $data"?: PdpSharedOriginalLanguageProvider_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedOriginalLanguageProvider_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedOriginalLanguageProvider_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "59d0823ae3b9a4336def1116df0a9058";

export default node;
